import { render, staticRenderFns } from "./WorkshopCalendar.vue?vue&type=template&id=51baa8a0&scoped=true"
import script from "./WorkshopCalendar.vue?vue&type=script&lang=js"
export * from "./WorkshopCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51baa8a0",
  null
  
)

export default component.exports